import React, { useState } from "react";
import Carousel from "react-bootstrap/Carousel";

export default function CarouselSection(Type) {
  const [index, setIndex] = useState(0);
  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  return (
    <div className="container">
      {Type.type === "index" && (
        <Carousel activeIndex={index} onSelect={handleSelect}>
          <Carousel.Item>
            <p>
              so, for the past 7 years i’ve been supplementing my income as an
              on-demand driver, and i must admit having to deal with customers
              in my car has been very challenging. PckitUp allows me to continue
              making money with my car, but without the customer backseat
              hassle. this business model fits me perfectly.
            </p>
            <Carousel.Caption>
              <span>TJ Holmes - PckitUp agent</span>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <p>
              oh my god! i absolutely love this service and i can’t believe that
              it’s taken so long for someone to think of this idea! we have a
              family with two kids and every week our garbage can is overstuffed
              with trash, and we simply can’t wait for the next week's city
              garbage pickup. i hate seeing the trash just sit there, thank you
              PckitUp!
            </p>
            <Carousel.Caption>
              <span>Samantha Burke - PckitUp customer</span>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <p>
              i’ve been unemployed for a considerable amount of time because my
              job was outsourced. PckitUp has provided me the opportunity to
              start a new career with an outcome of success totally in my
              control. all I need is my truck, a phone and the PckitUp app as a
              ‘tool chest’ for success! thank you PckitUp!!
            </p>
            <Carousel.Caption>
              <span>Carlos Santana - PckitUp Agent</span>
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>
      )}
      {Type.type === "customer" && (
        <Carousel activeIndex={index} onSelect={handleSelect}>
          <Carousel.Item>
            <p>
              this is a game changing service! now i don't have to personally
              manage my trash disposal and recycling.
            </p>
            <Carousel.Caption>
              <span>B Sanders - PckitUp customer</span>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <p>
              oh my God! i absolutely love this service and i can’t believe that
              it’s taken so long for someone to think of this idea! we have a
              family with two kids and every week our garbage can is overstuffed
              with trash, and we simply can’t wait for the next week's City
              Garbage pickup. i hate seeing the trash just sit there; thank you
              PckitUp!
            </p>
            <Carousel.Caption>
              <span>Samantha Burke - PckitUp customer</span>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <p>
              every time I make an online purchase, i'm constantly worrying
              about the excess cardboard boxes that are used to package my
              orders...PckitUp has helped me manage the excess waste!
            </p>
            <Carousel.Caption>
              <span>Maria Fuentes - PckitUp customer</span>
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>
      )}
      {Type.type === "agent" && (
        <Carousel activeIndex={index} onSelect={handleSelect}>
          <Carousel.Item>
            <p>
              so, for the past 7 years I’ve been supplementing my income as an
              on-demand driver, and i must admit having to deal with customers
              in my car has been very challenging. PckitUp allows me to continue
              making money with my car, but without the customer backseat
              hassle. this business model fits me perfectly.
            </p>
            <Carousel.Caption>
              <span>TJ Holmes - PckitUp agent</span>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <p>
              i’ve been unemployed for a considerable amount of time because my
              job was outsourced. PckitUp has provided me the opportunity to
              start a new career with an outcome of success totally in my
              control. all I need is my truck, a phone and the PckitUp app as a
              ‘tool chest’ for success! thank you PckitUp!!
            </p>
            <Carousel.Caption>
              <span>Carlos Santana - PckitUp agent</span>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <p>
              2020 has ushered in a new norm. the era of the gig economy has
              been challenged by the COVID-19 pandemic. i used to be a Lyft and
              Uber driver, but PckitUp has provided a more viable alternative
              that allows for social distancing while generating revenue.
              because of PckitUp, i can take care of my family.
            </p>
            <Carousel.Caption>
              <span>Ryan Conner - PckitUp agent</span>
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>
      )}
    </div>
  );
}
